"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.habitatRestorationProject = exports.treeProject = exports.carbonOffsetProject = exports.carbonRemovalProject = void 0;
const projects_1 = require("../../projects");
exports.carbonRemovalProject = {
    id: 5706,
    category: projects_1.Category.CarbonRemoval,
    title: 'Biochar Carbon Removal',
    description: 'Capturing carbon by generating biochar',
    slug: 'biochar-carbon-removal',
    snippets: {
        short: 'Biochar removes carbon',
        long: 'Biochar really does remove carbon',
    },
    sdgs: [7, 8, 13],
    images: [
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20220128160818/Aleo-Manali-Hydropower3-1024x768.jpeg',
            caption: '',
            createdAt: new Date('2022-01-28T16:08:18.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20220128160824/Aleo-Manali-Hydropower4.jpeg',
            caption: '',
            createdAt: new Date('2022-01-28T16:08:24.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20220128160829/Aleo-Manali-Hydropower2.jpeg',
            caption: '',
            createdAt: new Date('2022-01-28T16:08:29.000Z'),
        },
    ],
    location: {
        latLong: [32.22706664564586, 77.19825676919339],
        name: 'Biochar removal project',
    },
    treeSpecies: [],
    projectType: 'biochar',
    certifications: [],
    projectSize: 'small-scale',
    metaImage: '',
    wildflowerSpecies: [],
    impactDescription: 'This project will provide {{x}} jobs',
    impactAmount: '27',
};
exports.carbonOffsetProject = {
    id: 97,
    category: projects_1.Category.CarbonAvoidance,
    title: 'Improved cooking stoves in Kenya',
    description: 'The new stoves require less wood fuel (than traditional stoves) to cook a meal.',
    slug: 'improved-cooking-stoves-in-kenya',
    snippets: {
        short: 'Improved clean cookstoves in Aberdares, Kenya',
        long: 'Distributing more efficient cookstoves in Aberdares, Kenya to reduce emissions',
    },
    sdgs: [3, 13, 15],
    metaImage: '',
    images: [
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20190723164944/IMG_5222.jpg-1024x683.jpg',
            caption: '',
            createdAt: new Date('2019-07-23T14:49:39.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20190723165019/Kenya-Cook-Stove-6.jpg-1024x768.jpg',
            caption: '',
            createdAt: new Date('2019-07-23T14:50:18.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20190723165027/Kenya-Cook-Stove-7.jpg-1024x768.jpg',
            caption: '',
            createdAt: new Date('2019-07-23T14:50:26.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20190723165030/West-Kisumu-Cook-Stove-Project-2.jpg.jpg',
            caption: '',
            createdAt: new Date('2019-07-23T14:50:29.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20190723165032/West-Kisumu-Cook-Stove-Project-4.jpg.jpg',
            caption: '',
            createdAt: new Date('2019-07-23T14:50:32.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20190723165037/West-Kisumu-Cook-Stove-Project-1.jpg-1024x768.jpg',
            caption: '',
            createdAt: new Date('2019-07-23T14:50:36.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20190723165039/West-Kisumu-Cook-Stove-Project-6.jpg.jpg',
            caption: '',
            createdAt: new Date('2019-07-23T14:50:39.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20190723165044/West-Kisumu-Cook-Stove-Project-12.jpg-1024x768.jpg',
            caption: '',
            createdAt: new Date('2019-07-23T14:50:44.000Z'),
        },
    ],
    location: {
        latLong: [-0.790726, 37.086512],
        name: 'Aberdares, Kenya',
    },
    treeSpecies: [],
    wildflowerSpecies: [],
    certifications: [projects_1.ProjectCertification.GoldStandard],
    projectType: projects_1.CarbonAvoidanceProjectType.Community,
    projectSubType: null,
    projectSize: projects_1.ProjectSize.Small,
    impactDescription: 'This project will provide {{x}} families with clean drinking water',
    impactAmount: '2560',
};
exports.treeProject = {
    id: 3503,
    category: projects_1.Category.TreePlanting,
    title: 'Forest restoration in Kenya',
    description: 'Forest restoration in Kenya',
    slug: 'forest-restoration-in-kenya',
    snippets: {
        short: 'Afromontane forest restoration in southwestern Kenya',
        long: 'Planting native afromontane species to restore forest land in southwestern Kenya',
    },
    sdgs: [1, 2, 3, 4, 5, 8, 13, 15],
    metaImage: '',
    images: [
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20210720110739/20210310_114809-1024x576.jpeg',
            caption: '',
            createdAt: new Date('2021-07-20T09:07:38.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20210720110807/20210310_115639-1024x576.jpeg',
            caption: '',
            createdAt: new Date('2021-07-20T09:08:06.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20210720110815/20210310_132517-1024x576.jpeg',
            caption: '',
            createdAt: new Date('2021-07-20T09:08:14.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20210720110823/20210311_083047-1024x576.jpeg',
            caption: '',
            createdAt: new Date('2021-07-20T09:08:21.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20210720110832/20210311_083809-1024x768.jpeg',
            caption: '',
            createdAt: new Date('2021-07-20T09:08:30.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20210720110842/20210311_084837-1024x576.jpeg',
            caption: '',
            createdAt: new Date('2021-07-20T09:08:41.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20210720111136/IMG_20200424_114137wm-1024x484.jpeg',
            caption: '',
            createdAt: new Date('2021-07-20T09:11:35.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20210720111143/IMG_20200508_094728wm-1024x484.jpeg',
            caption: '',
            createdAt: new Date('2021-07-20T09:11:42.000Z'),
        },
    ],
    location: {
        latLong: [-0.3903347935702358, 35.51811983944913],
        name: 'Mau Region, Kenya',
    },
    treeSpecies: [
        'Acacia gerrardii',
        'Acacia kirkii',
        'Acacia xanthophloea',
        'Avicennia marina',
        'Avocado',
        'Bridelia micrantha',
        'Bruguiera gymnortiiza',
        'Calodendrum capense',
        'Ceriops tagal',
        'Cordia africana',
        'Cordia sinensis',
        'Croton machrostachyus',
        'Croton megalocarpus',
        'Dodonaea viscosa',
        'Dombeya torrida',
        'Euclea divinorum',
        'Ficus sur',
        'Ficus sycomorus',
        'Ficus thonningii',
        'Juniperus procera',
        'Lemon',
        'Loquat',
        'Maesopsis eminii',
        'Markhamia lutea',
        'Moringa (Moringa oleifera)',
        'Myrsine africana',
        'Nuxia congesta',
        'Olea africana',
        'Papaya',
        'Podocarpus falcatus',
        'Podocarpus latifolius',
        'Prunus africana',
        'Rhizophora mucronata',
        'Sesbania sesbans',
        'Sonneratia alba',
        'Trilepisium madagascariense',
        'Vepris simplicifolia',
        'Warburgia ugandensis',
        'Yushania alpina',
        'Zanthoxylum usambarense',
    ],
    wildflowerSpecies: [''],
};
exports.habitatRestorationProject = {
    id: 4826,
    category: projects_1.Category.HabitatRestoration,
    title: 'Restoring Wildflowers, Wetlands and Wildlife',
    description: 'Wildflower, Wetland and Wildlife restoration',
    slug: 'support-wildflowers-wetlands-and-wildlife',
    snippets: {
        short: 'Wildflowers are good for bees',
        long: 'Wildflowers really do good things',
    },
    sdgs: [7, 8, 13],
    images: [
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20220128160818/Aleo-Manali-Hydropower3-1024x768.jpeg',
            caption: '',
            createdAt: new Date('2022-01-28T16:08:18.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20220128160824/Aleo-Manali-Hydropower4.jpeg',
            caption: '',
            createdAt: new Date('2022-01-28T16:08:24.000Z'),
        },
        {
            url: 'https://cms-assets.offset.earth/app/uploads/20220128160829/Aleo-Manali-Hydropower2.jpeg',
            caption: '',
            createdAt: new Date('2022-01-28T16:08:29.000Z'),
        },
    ],
    location: {
        latLong: [32.22706664564586, 77.19825676919339],
        name: 'Wildflower project',
    },
    treeSpecies: [],
    projectType: 'wildflowers',
    certifications: [],
    projectSize: 'small-scale',
    metaImage: '',
    wildflowerSpecies: [],
    impactDescription: 'Wildflowers in the UK is down by {{x}}%',
    impactAmount: '97',
};
//# sourceMappingURL=data:application/json;base64,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